import React, {FunctionComponent, useMemo} from 'react';
import {IQueryParams} from "../../../../types/IQueryParams";
import {UrlBuilder} from "../../../../utils/urlBuilder";

import './ReverseRouteLink.css';
import TranslatedText from "../../../ui/TranslatedText/TranslatedText";
import UITranslations from "../../../../store/uiTranslations";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as _ from 'lodash'
import {Routes} from "../../../../routes";
import { analytics } from '../../../..';
import { AnalyticsEvents } from '../../../../store/AnalyticsStore';

interface IReverseRouteLink{
    queryParams: IQueryParams;
}

const ReverseRouteLink:FunctionComponent<IReverseRouteLink> = ({queryParams})=>{
    const isEmbeded = useMemo(() => window.self !== window.top, []);

    let reverseQuery:IQueryParams = {
        ...queryParams,
        nodeFrom:queryParams.nodeTo,
        nodeTo:queryParams.nodeFrom,
        channel: !isEmbeded ? "ReversedRoute" : "ReversedRouteCMS",
    };
    // reverseQuery = _.omit(reverseQuery, "channel")
    const reverseRouteUrl = UrlBuilder.Relative(Routes.PhotoRoute).searchParams(reverseQuery).href;

    return <a onClick={() => {
        analytics.logEvent(AnalyticsEvents.SwapStartDestination)
    }} href={reverseRouteUrl} className="reverse-route-link">
        <FontAwesomeIcon icon="undo" className='reverse-icon'/>
        <TranslatedText source={UITranslations.PhotoRoutePage.ReverseRouteLink}/>
    </a>
}

export default ReverseRouteLink;
